import { useState, useEffect } from "react";
import { Radio, Users } from "lucide-react";
import { useNavigate } from "react-router-dom";

const newsItems = [
  {
    id: "mcp",
    text: "MCP Server for phone call now available",
    icon: Radio,
    href: "https://call24x7.ai",
    external: true,
  },
  {
    id: "referral",
    text: "New Referral Program - Join now and grow with us!",
    icon: Users,
    href: "/referral",
    external: false,
  },
];

const RotatingNewsBanner = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % newsItems.length);
        setIsVisible(true);
      }, 300);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  const currentNews = newsItems[currentIndex];
  const IconComponent = currentNews.icon;

  const handleClick = () => {
    if (currentNews.external) {
      window.open(currentNews.href, "_blank");
    } else {
      navigate(currentNews.href);
    }
  };

  return (
    <div
      onClick={handleClick}
      className="block fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-primary via-secondary to-accent py-2 px-4 hover:opacity-90 transition-opacity cursor-pointer"
    >
      <div className="container mx-auto flex items-center justify-center gap-2">
        <IconComponent
          className={`w-4 h-4 text-primary-foreground animate-slow-pulse transition-opacity duration-300 ${
            isVisible ? "opacity-100" : "opacity-0"
          }`}
        />
        <p
          className={`text-sm md:text-base font-semibold text-primary-foreground transition-opacity duration-300 ${
            isVisible ? "opacity-100" : "opacity-0"
          }`}
        >
          {currentNews.text}
        </p>
      </div>
    </div>
  );
};

export default RotatingNewsBanner;
